export const loadFromLocalStorage = ({
  storageKey = '',
  key,
}: {
  storageKey?: string
  key: string
}) => {
  try {
    const unserialised = localStorage.getItem(`${storageKey}_${key}`)

    if (unserialised === null) {
      return undefined
    }
    return JSON.parse(unserialised)
  } catch (error) {
    return undefined
  }
}

export const saveToLocalStorage = ({
  storageKey = '',
  key,
  data,
  session,
}: {
  storageKey?: string
  key: string
  data: any
  session?: boolean
}) => {
  try {
    const serialisedState = JSON.stringify(data)
    session
      ? sessionStorage.setItem(`${storageKey}_${key}`, serialisedState)
      : localStorage.setItem(`${storageKey}_${key}`, serialisedState)
  } catch (error) {
    // add log
  }
}
